import {
  BsBook,
  BsCameraVideo,
  BsController,
  BsGift,
  BsHeadset,
  BsJournalText,
  BsMegaphone,
  BsMortarboard,
  BsPuzzle,
  BsStars,
} from "react-icons/bs";
import { HiOutlineRocketLaunch, HiOutlineSparkles } from "react-icons/hi2";
import { TbWand } from "react-icons/tb";

export const UPDATES_PAGE_SIZE = 5;

export const UPDATE_ICON_OPTIONS = [
  { key: "rocket", Icon: HiOutlineRocketLaunch, label: "Запуск" },
  { key: "gamepad", Icon: BsController, label: "Игра" },
  { key: "puzzle", Icon: BsPuzzle, label: "Новинка" },
  { key: "magic", Icon: TbWand, label: "Улучшение" },
  { key: "book", Icon: BsBook, label: "Материал" },
  { key: "sparkles", Icon: HiOutlineSparkles, label: "Обновление" },
  { key: "megaphone", Icon: BsMegaphone, label: "Объявление" },
  { key: "gift", Icon: BsGift, label: "Бонус" },
  { key: "classroom", Icon: BsCameraVideo, label: "Классная комната" },
  { key: "program", Icon: BsMortarboard, label: "Программа" },
  { key: "support", Icon: BsHeadset, label: "Поддержка" },
  { key: "journal", Icon: BsJournalText, label: "Журнал учеников" },
];

export const UPDATE_ICON_KEYS = new Set(
  UPDATE_ICON_OPTIONS.map((option) => option.key),
);

export const DEFAULT_UPDATE_ICON_KEY = "sparkles";

export const UPDATE_SECTIONS = [
  {
    key: "platform",
    label: "Платформа",
    iconKey: "sparkles",
    Icon: HiOutlineSparkles,
  },
  { key: "games", label: "Игры", iconKey: "gamepad", Icon: BsController },
  {
    key: "classroom",
    label: "Классная комната",
    iconKey: "classroom",
    Icon: BsCameraVideo,
  },
  { key: "library", label: "Библиотека", iconKey: "book", Icon: BsBook },
  {
    key: "program",
    label: "Программа",
    iconKey: "program",
    Icon: BsMortarboard,
  },
  { key: "support", label: "Поддержка", iconKey: "support", Icon: BsHeadset },
  {
    key: "journal",
    label: "Журнал учеников",
    iconKey: "journal",
    Icon: BsJournalText,
  },
];

export const UPDATE_SECTION_KEYS = new Set(
  UPDATE_SECTIONS.map((section) => section.key),
);

export const DEFAULT_UPDATE_SECTION_KEY = "platform";

export const getUpdateSection = (key) =>
  UPDATE_SECTIONS.find((section) => section.key === key) ||
  UPDATE_SECTIONS[0];

export const getUpdateIconComponent = (key) => {
  const section = UPDATE_SECTIONS.find((item) => item.iconKey === key);
  if (section) return section.Icon;
  const option = UPDATE_ICON_OPTIONS.find((item) => item.key === key);
  return option?.Icon || BsStars;
};
